import { transparentize } from 'polished'
import styled from 'styled-components'

export const CatalogItemDetailsImageWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${(props) => props.theme.typography.pxToRem(163)};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};
  background: ${(props) => transparentize(0.95, props.theme.colors.darkGreen)};
  overflow: hidden;
`
